"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDeclined = void 0;

var _InboxErrors = require("../constants/InboxErrors");

var _ActionTypes = require("./ActionTypes");

var userDeclined = function userDeclined() {
  return {
    type: _ActionTypes.PERMISSIONS_ERROR,
    payload: {
      message: _InboxErrors.USER_DECLINED
    }
  };
};

exports.userDeclined = userDeclined;